import type { ExcalidrawImperativeAPI } from "@excalidraw/excalidraw/types";

// FLF Draw: sem os recursos de IA do Excalidraw (oss-ai.excalidraw.com).
// O dialogo "Mermaid para diagrama" continua: o LayerUI do Excalidraw renderiza
// a versao padrao (so Mermaid, roda no navegador) quando o app nao fornece a sua.
export const AIComponents = (_props: {
  excalidrawAPI: ExcalidrawImperativeAPI;
}) => {
  return null;
};
